module.exports = __webpack_public_path__ + "static/media/healthcare-brown.f1bd9fcb.svg";